export default __webpack_public_path__ + "static/media/Punto_09_Mercato_Centrale_DEU_Def.f3141123.aac";